import { GridStackOptions } from 'gridstack';

export const gridDefaultOptions: GridStackOptions = {
    float: false,
    cellHeight: 100,
    column: 12, // Default number of columns for desktop
    margin: 5,
    columnOpts: {
        breakpoints: [
            { w: 1024, c: 1 }, // For screen widths <= 768px, use 1 column
        ],
        breakpointForWindow: true, // Use window size for breakpoints
        layout: 'moveScale', // Re-layout mode when changing columns
    },
    draggable: {
        handle: '.Drag__pan',
    },
    animate: true, // Optional: Enable animations for smoother transitions
};
